import design from './zh-TW/design';
import menu from './zh-TW/menu';
import mockup from './zh-TW/mockup';
import pages from './zh-TW/pages';

export default {
  'navBar.lang': '語言',
  ...menu,
  ...pages,
  ...mockup,
  ...design,
};
